
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20.142 14.743a7.589 7.589 0 00-9.295-5.366 7.44 7.44 0 00-4.89 4.173l1.454-.395a1 1 0 01.523 1.93l-3.17.86a.994.994 0 01-.109.03l-.405.11a1 1 0 01-1.228-.707l-.988-3.687a1 1 0 111.932-.518l.326 1.219a9.424 9.424 0 016.038-4.947 9.589 9.589 0 0111.744 6.78 1 1 0 01-1.932.518z"}})])
          )
        }
      }
    